<template>
  <div>
    <div align="left">
      <h5 class="h5 mb-3 text-primary font-weight-bold">Article</h5>
    </div>
    <br />
    <b-card class="text-left">
      <h5 class="font-weight-bold text-primary">Create New Rate</h5>
      <br />
      <br />
      <b-row>
        <b-col>
          <div>
            <b-tabs content-class="mt-3" justified>
              <b-tab title="Shipment" active>
                <app-shipment :reasonList="reasonList"></app-shipment>
              </b-tab>
              <b-tab title="First Mile">
                <app-fm :reasonList="reasonList"></app-fm>
              </b-tab>
              <b-tab title="Last Mile">
                <app-lm :reasonList="reasonList"></app-lm>
              </b-tab>
            </b-tabs>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import Shipment from '../component/rate/createShipment';
import FM from '../component/rate/createFM';
import LM from '../component/rate/createLM';

export default {
  components: {
    appShipment: Shipment,
    appFm: FM,
    appLm: LM,
  },
  data() {
    return {
      reasonList: [],
    };
  },
  beforeCreate() {
    // this.$store.dispatch("getDonatur");
    this.$store.dispatch('RatingModule/getReasons');
  },
  created() {
    this.$store.watch(
      state => state.RatingModule.reason,
      (newValue, oldValue) => {
        this.reasonList = newValue;
      },
    );
  },
  methods: {},
};
</script>

<style scoped>
</style>
